<template>
  <div>
    <el-select
      :value="value"
      clearable
      :placeholder="`${$t('placeHolder.pleaseSelect')} ${placeholder}`"
      size="mini"
      @change="(val) => change(val)"
    >
      <el-option
        v-for="item in options"
        :key="item.value ? item.value : item"
        :label="item.label ? item.label : item"
        :value="item.value ? item.value : item"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "Y-select",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: "",
    },
    placeholder: String,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    change(val) {
      this.$emit('update:value', val);
      this.$emit("change", val);
    }
  },
  components: {},
};
</script>

<style scoped lang="scss"></style>
